import { useState, useEffect } from "react";

const links = {
  loanApplication: "/LoanApplication/",
  login: "/User/Login/",
  webAnalytics: "/utilities/wa.gif",
};

const prefixes: {
  [key: string]: { match?: string; links: { secure: string } };
} = {
  cloudfront: {
    match: "d2ezcve1w80hv0.cloudfront.net",
    links: { secure: "https://secure-dev.cashmoney.ca" },
  },
  pre: { match: "-pre", links: { secure: "https://secure-pre.cashmoney.ca" } },
  dev: { match: "-dev", links: { secure: "https://secure-dev.cashmoney.ca" } },
  localhost: {
    match: "localhost|10.",
    links: { secure: "https://secure-dev.cashmoney.ca" },
  },
  prod: { links: { secure: "https://secure.cashmoney.ca" } },
  //prod should always be last
};

export type SecureLinksResult = typeof links;

const prefixLinks = ({
  links,
  env,
}: {
  links: SecureLinksResult;
  env: keyof typeof prefixes;
}) =>
  Object.keys(links).reduce(
    (res, name) => ({
      ...res,
      [name]: prefixes[env].links.secure + links[name as keyof typeof links],
    }),
    {} as SecureLinksResult
  );

export function useSecureLinks(
  requireEnvironment?: boolean,
  Id?: string
): SecureLinksResult {
  const [env, setEnv] = useState<keyof typeof prefixes>("prod");
  const [secureLinks, setSecureLinks] = useState(
    !!requireEnvironment
      ? ({} as SecureLinksResult)
      : prefixLinks({ links, env: "prod" })
  );
  const [queryId, setQueryId] = useState(Id);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("Id");
    id && setQueryId(id);
  }, []);
  useEffect(() => {
    const domain = window.location.hostname;

    let newEnv: keyof typeof prefixes | undefined = Object.keys(prefixes).find(
      (e) => {
        const env = prefixes[e as keyof typeof prefixes];
        return !!env.match && !!domain.match(env.match)?.length;
      }
    );
    if (!newEnv) newEnv = "prod";
    console.log(newEnv);
    if (env !== newEnv) setEnv(newEnv);
  }, []);
  useEffect(() => {
    const prefixedLinks = prefixLinks({ links, env });
    setSecureLinks(prefixedLinks);
  }, [env]);
  useEffect(() => {
    setSecureLinks((prev) => ({
      ...prev,
      loanApplication: queryId
        ? prev.loanApplication +
          `?Id=${queryId}&utm_source=loanscanadaCA&utm_campaign=test1`
        : prev.loanApplication,
    }));
  }, [queryId]);

  return secureLinks;
}
